import './main.less';

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import Select from 'react-select';

import _prop from 'lodash/fp/prop';
import _compose from 'lodash/fp/compose';

class Main extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			options: props.availableLanguages.map(lang => ({ value: lang, label: props.intl(lang) }))
		};
	}

	render() {
		return (
			<div className={cn({
				'langs-switcher': true,
				'lang-icon': true,
				[this.props.lang === 'ru' ? 'ru' : 'en']: true,
				'inverse-color': this.props.isHamburgerActive
			})}>
				<Select
					value={this.props.lang === 'ru' ? 'ru' : 'en'}
					options={this.state.options}
					searchable={false}
					clearable={false}
					onChange={_compose(this.props.changeLang, _prop('value'))}
				/>
			</div>
		);
	}
}

Main.propTypes = {
	lang: PropTypes.string,
	intl: PropTypes.func,
	availableLanguages: PropTypes.array,
	changeLang: PropTypes.func,
	isHamburgerActive: PropTypes.bool
};

export default Main;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/langs/main.js